import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

const AddImageDialog = ({ open, onClose, onAddPhotos }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      
      {/* Close Icon */}
      <Button
        onClick={onClose}
        sx={{
          position: "absolute",
          left: 10,
          top: 10,
          minWidth: "auto",
          fontSize: 18,
        }}
      >
        ✕
      </Button>

      <DialogContent
        style={{
          textAlign: "center",
          padding: "30px 20px",
        }}
      >
        {/* Illustration */}
        <img
           src="assets/img/logo.svg"
          alt="upload"
          style={{
            width: 160,
            margin: "20px auto",
          }}
        />

        {/* Title */}
        <h2
          style={{
            fontWeight: 700,
            fontSize: 22,
            marginBottom: 10,
          }}
        >
          Add Property Images to Continue
        </h2>

        {/* Description */}
        <p
          style={{
            fontSize: 14,
            color: "#6b7280",
            lineHeight: 1.5,
            marginBottom: 25,
          }}
        >
          Uploading property images is mandatory to list your property.
          Images help buyers understand the property better and build trust.
          Without images, your property will not be visible to users.
        </p>

        {/* Bottom Buttons */}
        <div
          style={{
            display: "flex",
            gap: 12,
          }}
        >
          {/* Skip */}
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: 10,
              border: "1px solid #16a34a",
              background: "#fff",
              color: "#16a34a",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Skip
          </button>

          {/* Add Photos */}
          <button
            onClick={onAddPhotos}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: 10,
              border: "none",
              background: "#16a34a",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Add Photos
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};



export default AddImageDialog;
